import join from 'url-join'

import { createAction, http, asyncAction } from '../util'
import config from '../config'

const api = join.bind(null, config.apiUrl)

export const getAppStatus = asyncAction({
    basename: 'APP_STATUS_GET',
    action: action => () => (dispatch) => {
        dispatch(action.start())
        return http.get(api(`/ssp/status`))
        .then(response => {
            dispatch(action.success(response))
        }).catch(err => {
            console.error('error getting app status api response', err)
            alert ("You MUST be connected to the Nike VPN to use this tool."+'\n'+" Please properly connect and reload this page");
            dispatch(action.error(err))
        })
    }
})



// WEBPACK FOOTER //
// ./client/src/appStatus/actions.js